import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/favoriteLists/favoriteListQueryKeys.ts
var t = e("favoriteLists", {
	list: () => ["list"],
	detail: (e) => ["detail", e],
	feed: () => ["feed"]
});
//#endregion
export { t as favoriteListQueryKeys };
